import React from 'react';
import PropTypes from 'prop-types';

var DidomiSDK = function DidomiSDK(_ref) {
  var _ref$apiKey = _ref.apiKey,
      apiKeyProp = _ref$apiKey === undefined ? null : _ref$apiKey,
      _ref$iabVersion = _ref.iabVersion,
      iabVersion = _ref$iabVersion === undefined ? 2 : _ref$iabVersion,
      _ref$noticeId = _ref.noticeId,
      noticeId = _ref$noticeId === undefined ? null : _ref$noticeId,
      _ref$config = _ref.config,
      config = _ref$config === undefined ? {} : _ref$config,
      _ref$gdprAppliesGloba = _ref.gdprAppliesGlobally,
      gdprAppliesGloballyProp = _ref$gdprAppliesGloba === undefined ? true : _ref$gdprAppliesGloba,
      onReady = _ref.onReady,
      onConsentChanged = _ref.onConsentChanged,
      onNoticeShown = _ref.onNoticeShown,
      onNoticeHidden = _ref.onNoticeHidden,
      onNoticeBackdropclick = _ref.onNoticeBackdropclick,
      onNoticeClickAgree = _ref.onNoticeClickAgree,
      onNoticeClickMoreInfo = _ref.onNoticeClickMoreInfo,
      onPreferencesClickAgreeToAll = _ref.onPreferencesClickAgreeToAll,
      onPreferencesClickDisagreeToAll = _ref.onPreferencesClickDisagreeToAll,
      onPreferencesClickPurposeAgree = _ref.onPreferencesClickPurposeAgree,
      onPreferencesClickPurposeDisagree = _ref.onPreferencesClickPurposeDisagree,
      onPreferencesClickViewVendors = _ref.onPreferencesClickViewVendors,
      onPreferencesClickSaveChoices = _ref.onPreferencesClickSaveChoices,
      onPreferencesClickVendorAgree = _ref.onPreferencesClickVendorAgree,
      onPreferencesClickVendorDisagree = _ref.onPreferencesClickVendorDisagree,
      onPreferencesClickVendorSaveChoices = _ref.onPreferencesClickVendorSaveChoices,
      _ref$sdkPath = _ref.sdkPath,
      sdkPath = _ref$sdkPath === undefined ? 'https://sdk.privacy-center.org/' : _ref$sdkPath,
      _ref$embedTCFStub = _ref.embedTCFStub,
      embedTCFStub = _ref$embedTCFStub === undefined ? true : _ref$embedTCFStub;

  /**
   * Set all the Didomi event listeners from the props
   */
  var setEvents = function setEvents() {
    if (onReady) {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(onReady);
    }

    window.didomiEventListeners = window.didomiEventListeners || [];

    if (onConsentChanged) {
      window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: function listener(e) {
          onConsentChanged(e.consentToken);
        }
      });
    }

    if (onNoticeShown) {
      window.didomiEventListeners.push({
        event: 'notice.shown',
        listener: function listener() {
          return onNoticeShown();
        }
      });
    }

    if (onNoticeHidden) {
      window.didomiEventListeners.push({
        event: 'notice.hidden',
        listener: function listener() {
          return onNoticeHidden();
        }
      });
    }

    if (onNoticeBackdropclick) {
      window.didomiEventListeners.push({
        event: 'notice.backdropclick',
        listener: function listener() {
          return onNoticeBackdropclick();
        }
      });
    }

    if (onNoticeClickAgree) {
      window.didomiEventListeners.push({
        event: 'notice.clickagree',
        listener: function listener() {
          return onNoticeClickAgree();
        }
      });
    }

    if (onNoticeClickMoreInfo) {
      window.didomiEventListeners.push({
        event: 'notice.clickmoreinfo',
        listener: function listener() {
          return onNoticeClickMoreInfo();
        }
      });
    }

    if (onPreferencesClickAgreeToAll) {
      window.didomiEventListeners.push({
        event: 'preferences.clickagreetoall',
        listener: function listener() {
          return onPreferencesClickAgreeToAll();
        }
      });
    }

    if (onPreferencesClickDisagreeToAll) {
      window.didomiEventListeners.push({
        event: 'preferences.clickdisagreetoall',
        listener: function listener() {
          return onPreferencesClickDisagreeToAll();
        }
      });
    }

    if (onPreferencesClickPurposeAgree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickpurposeagree',
        listener: function listener() {
          return onPreferencesClickPurposeAgree();
        }
      });
    }

    if (onPreferencesClickPurposeDisagree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickpurposedisagree',
        listener: function listener() {
          return onPreferencesClickPurposeDisagree();
        }
      });
    }

    if (onPreferencesClickViewVendors) {
      window.didomiEventListeners.push({
        event: 'preferences.clickviewvendors',
        listener: function listener() {
          return onPreferencesClickViewVendors();
        }
      });
    }

    if (onPreferencesClickSaveChoices) {
      window.didomiEventListeners.push({
        event: 'preferences.clicksavechoices',
        listener: function listener() {
          return onPreferencesClickSaveChoices();
        }
      });
    }

    if (onPreferencesClickVendorAgree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendoragree',
        listener: function listener() {
          return onPreferencesClickVendorAgree();
        }
      });
    }

    if (onPreferencesClickVendorDisagree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendordisagree',
        listener: function listener() {
          return onPreferencesClickVendorDisagree();
        }
      });
    }

    if (onPreferencesClickVendorSaveChoices) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendorsavechoices',
        listener: function listener() {
          return onPreferencesClickVendorSaveChoices();
        }
      });
    }
  };

  /**
   * Get the API Key from the props or from the config if it exists
   */
  var getApiKey = function getApiKey() {
    var apiKey = void 0;
    if (config.app && config.app.apiKey) {
      apiKey = config.app.apiKey;
    }
    return apiKeyProp || apiKey;
  };

  /**
   * Initialize the SDK, set the config object and insert the loader.js into the DOM
   */
  var init = function init() {
    var loaderParams = void 0;
    var apiKey = getApiKey();
    var gdprAppliesGlobally = gdprAppliesGloballyProp === false ? false : true;
    window.didomiConfig = config || {};

    // Set the SDK path
    window.didomiConfig.sdkPath = sdkPath;

    // Embed the Didomi SDK on the page
    window.gdprAppliesGlobally = gdprAppliesGlobally;
    if (noticeId) {
      loaderParams = 'target_type=notice&target=' + noticeId;
    } else {
      loaderParams = 'target=' + document.location.hostname;
    }

    // Embed the TCF stub
    if (embedTCFStub) {
      if (iabVersion === 2) {
        // TCF v2
        // prettier-ignore
        (function () {
          function a(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;var n = document.createElement("iframe");n.style.display = "none";n.name = e;n.title = e;t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  a(e);
                }, 5);
              }
            }
          }function e(n, r, o, c, s) {
            function e(e, t, n, a) {
              if (typeof n !== "function") {
                return;
              }if (!window[r]) {
                window[r] = [];
              }var i = false;if (s) {
                i = s(e, t, n);
              }if (!i) {
                window[r].push({ command: e, parameter: t, callback: n, version: a });
              }
            }e.stub = true;function t(a) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }if (!a.data) {
                return;
              }var i = typeof a.data === "string";var e;try {
                e = i ? JSON.parse(a.data) : a.data;
              } catch (t) {
                return;
              }if (e[o]) {
                var r = e[o];window[n](r.command, r.parameter, function (e, t) {
                  var n = {};n[c] = { returnValue: e, success: t, callId: r.callId };a.source.postMessage(i ? JSON.stringify(n) : n, "*");
                }, r.version);
              }
            }if (typeof window[n] !== "function") {
              window[n] = e;if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");a("__tcfapiLocator");
        })();
      } else {
        // TCF v1
        // prettier-ignore
        (function () {
          function r() {
            if (!window.frames.__cmpLocator) {
              if (document.body && document.body.firstChild) {
                var e = document.body;var t = document.createElement("iframe");t.style.display = "none";t.name = "__cmpLocator";t.title = "cmpLocator";e.insertBefore(t, e.firstChild);
              } else {
                setTimeout(r, 5);
              }
            }
          }function e(e, t, r) {
            if (typeof r !== "function") {
              return;
            }if (!window.__cmpBuffer) {
              window.__cmpBuffer = [];
            }if (e === "ping") {
              r({ gdprAppliesGlobally: window.gdprAppliesGlobally, cmpLoaded: false }, true);
            } else {
              window.__cmpBuffer.push({ command: e, parameter: t, callback: r });
            }
          }e.stub = true;function t(a) {
            if (!window.__cmp || window.__cmp.stub !== true) {
              return;
            }if (!a.data) {
              return;
            }var n = typeof a.data === "string";var e;try {
              e = n ? JSON.parse(a.data) : a.data;
            } catch (t) {
              return;
            }if (e.__cmpCall) {
              var o = e.__cmpCall;window.__cmp(o.command, o.parameter, function (e, t) {
                var r = { __cmpReturn: { returnValue: e, success: t, callId: o.callId } };a.source.postMessage(n ? JSON.stringify(r) : r, "*");
              });
            }
          }if (typeof window.__cmp !== "function") {
            window.__cmp = e;if (window.addEventListener) {
              window.addEventListener("message", t, false);
            } else {
              window.attachEvent("onmessage", t);
            }
          }r();
        })();
      }
    }

    var spcloaderId = 'spcloader';
    var spcloaderScript = document.getElementById(spcloaderId);

    // Didomi is already loaded, no need to add the script again
    if (spcloaderScript) {
      return null;
    }

    // Embed the SDK
    var loaderScript = document.createElement('script');
    loaderScript.id = spcloaderId;
    loaderScript.type = 'text/javascript';
    loaderScript.async = true;
    loaderScript.src = sdkPath + apiKey + '/loader.js?' + loaderParams;
    loaderScript.charset = 'utf-8';

    var firstScriptTagInDocument = document.getElementsByTagName('script')[0];
    firstScriptTagInDocument.parentNode.insertBefore(loaderScript, firstScriptTagInDocument);
  };

  React.useEffect(function () {
    setEvents();
    init();
  }, []);

  return null;
};

DidomiSDK.propTypes = {
  apiKey: PropTypes.string,
  iabVersion: PropTypes.number,
  noticeId: PropTypes.string,
  config: PropTypes.object,
  gdprAppliesGlobally: PropTypes.bool,
  onReady: PropTypes.func,
  onConsentChanged: PropTypes.func,
  onNoticeShown: PropTypes.func,
  onNoticeHidden: PropTypes.func,
  onNoticeBackdropclick: PropTypes.func,
  onNoticeClickAgree: PropTypes.func,
  onNoticeClickMoreInfo: PropTypes.func,
  onPreferencesClickAgreeToAll: PropTypes.func,
  onPreferencesClickDisagreeToAll: PropTypes.func,
  onPreferencesClickPurposeAgree: PropTypes.func,
  onPreferencesClickPurposeDisagree: PropTypes.func,
  onPreferencesClickViewVendors: PropTypes.func,
  onPreferencesClickSaveChoices: PropTypes.func,
  onPreferencesClickVendorAgree: PropTypes.func,
  onPreferencesClickVendorDisagree: PropTypes.func,
  onPreferencesClickVendorSaveChoices: PropTypes.func,
  sdkPath: PropTypes.string,
  embedTCFStub: PropTypes.bool
};

export { DidomiSDK };